import { Tag } from '@lego/connect-components-react';
import type { VersionStatus } from '../../simulation-tool-page/utils/simulation-types';
import { getStatusOption } from '../../utils/simulation-status-helpers';

type Props = {
  status: VersionStatus;
  size?: 'small' | 'medium';
};

export const StatusTag = ({ status, size = 'medium' }: Props) => {
  const option = getStatusOption(status);

  return (
    <Tag
      variant={option?.variant ?? 'neutral'}
      aria-label={option?.tagLabel ?? 'Unknown'}
      size={size}
      style={option?.style}
    >
      {option?.tagLabel ?? 'Unknown'}
    </Tag>
  );
};
